<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="resetForm"
  >
    <a-form ref="formRef" :model="formState" :rules="rules">
      <a-form-item label="昵称" name="nickName">
        <a-input v-model:value="formState.nickName"></a-input>
      </a-form-item>
      <a-form-item label="账号" name="username">
        <a-input v-model:value="formState.username"></a-input>
      </a-form-item>
      <a-form-item label="密码" name="password">
        <a-input v-model:value="formState.password" />
      </a-form-item>
      <a-form-item label="账号类型" name="type">
        <a-select
          ref="select"
          v-model:value="formState.type"
          style="width: 120px"
        >
          <!-- <a-select-option value="0">超级管理员</a-select-option> -->
          <a-select-option value="1">售后</a-select-option>
          <a-select-option value="2">仓管</a-select-option>
          <a-select-option value="3">质检</a-select-option>
          <a-select-option value="4">工艺</a-select-option>
          <a-select-option value="5">生产</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { defineComponent, reactive, ref } from "vue";
import { saveOrUpdateUser } from "@/request/view/repair";
import { useStore } from "vuex";

export default defineComponent({
  setup(props, context) {
    const formRef = ref();
    const store = useStore();
    const modalConfig = reactive({
      title: "新增返修设备",
      visible: false,
    });

    const formState = reactive({
      pid: store.getters.user.id,
      nickName: null,
      password: null,
      type: null,
      username: null,
    });

    const rules = {
      nickName: [
        {
          required: true,
          message: "请输入昵称",
          trigger: "blur",
          type: "string",
        },
      ],
      username: [
        {
          required: true,
          message: "请输入账号",
          trigger: "blur",
          type: "string",
        },
      ],
      password: [
        {
          required: true,
          message: "请输入密码",
          trigger: "blur",
          type: "string",
        },
      ],
      type: [
        {
          required: true,
          message: "请选择账号类型",
          trigger: "blur",
          type: "string",
        },
      ],
    };

    const resetForm = () => {
      modalConfig.title = "";
      modalConfig.visible = false;
      formState.nickName = null;
      formState.password = null;
      formState.type = null;
      formState.username = null;
      formRef.value.clearValidate();
    };

    const handleOk = () => {
      formRef.value
        .validate()
        .then(() => {
          saveOrUpdateUser(formState).then((res) => {
            resetForm();
            context.emit("updateTable");
          });
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const showModal = () => {
      modalConfig.visible = true;
      modalConfig.title = "新增用户";
    };

    return {
      formRef,
      modalConfig,
      handleOk,
      formState,
      rules,
      showModal,
      resetForm,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
